import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { ReviewPackageUser } from '@portal-core/reviews/review-package-users/models/review-package-user.model';

@CollectionStateSelectors({
  stateType: ReviewPackageUsersState
})
@State<ReviewPackageUsersState>({
  name: ReviewPackageUsersState.source
})
@Service({ autoProvided: false })
export class ReviewPackageUsersState extends CollectionStateBase {
  static override source = 'ReviewPackageUsers';
  getSource(): string {
    return ReviewPackageUsersState.source;
  }
}

@Service()
export class ReviewPackageUsersDataService extends CollectionDataServiceBase<ReviewPackageUser> {
  protected readonly stateType = ReviewPackageUsersState;
}
